/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../common";
import type {
  EngagementDiscountTierManager,
  EngagementDiscountTierManagerInterface,
} from "../../contracts/EngagementDiscountTierManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IEngagementOracle",
        name: "oracle_",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "Manager_ConstantTier",
    type: "error",
  },
  {
    inputs: [],
    name: "Manager_InvalidOracle",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "maxLevel",
        type: "uint8",
      },
    ],
    name: "Manager_LargeTierList",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "percentage",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oneHundredPercent",
        type: "uint256",
      },
    ],
    name: "Manager_PercentageTooLarge",
    type: "error",
  },
  {
    inputs: [],
    name: "Manager_TierListEmpty",
    type: "error",
  },
  {
    inputs: [],
    name: "Manager_TierListNotSorted",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    name: "Manager_TierNotDefined",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "maxLevel",
        type: "uint8",
      },
    ],
    name: "Manager_TierNotFound",
    type: "error",
  },
  {
    inputs: [],
    name: "MathOverflowedMulDiv",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OwnableInvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "OwnableUnauthorizedAccount",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    name: "TierDiscountRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "discount",
        type: "uint256",
      },
    ],
    name: "TierDiscountSet",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "TiersCleared",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "applyDiscount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "clearTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getDiscount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getTier",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "discount",
            type: "uint256",
          },
        ],
        internalType: "struct IEngagementDiscountTierManager.TierWithLevel",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getUserLevel",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oracle",
    outputs: [
      {
        internalType: "contract IEngagementOracle",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    name: "removeTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IEngagementOracle",
        name: "oracle_",
        type: "address",
      },
    ],
    name: "setOracle",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "discount",
            type: "uint256",
          },
        ],
        internalType: "struct IEngagementDiscountTierManager.Tier",
        name: "tier_",
        type: "tuple",
      },
    ],
    name: "setTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "discount",
            type: "uint256",
          },
        ],
        internalType: "struct IEngagementDiscountTierManager.Tier[]",
        name: "tiers_",
        type: "tuple[]",
      },
    ],
    name: "setTiers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "level",
        type: "uint8",
      },
    ],
    name: "tier",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "discount",
            type: "uint256",
          },
        ],
        internalType: "struct IEngagementDiscountTierManager.TierWithLevel",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "tierStore",
    outputs: [
      {
        internalType: "uint256",
        name: "discount",
        type: "uint256",
      },
      {
        internalType: "bool",
        name: "defined",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tiers",
    outputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "level",
            type: "uint8",
          },
          {
            internalType: "uint256",
            name: "discount",
            type: "uint256",
          },
        ],
        internalType: "struct IEngagementDiscountTierManager.TierWithLevel[]",
        name: "",
        type: "tuple[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type EngagementDiscountTierManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: EngagementDiscountTierManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class EngagementDiscountTierManager__factory extends ContractFactory {
  constructor(...args: EngagementDiscountTierManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    oracle_: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(oracle_, owner_, overrides || {});
  }
  override deploy(
    oracle_: AddressLike,
    owner_: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(oracle_, owner_, overrides || {}) as Promise<
      EngagementDiscountTierManager & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(
    runner: ContractRunner | null
  ): EngagementDiscountTierManager__factory {
    return super.connect(runner) as EngagementDiscountTierManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): EngagementDiscountTierManagerInterface {
    return new Interface(_abi) as EngagementDiscountTierManagerInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): EngagementDiscountTierManager {
    return new Contract(
      address,
      _abi,
      runner
    ) as unknown as EngagementDiscountTierManager;
  }
}
